import React from 'react';
import FormInput from '@/components/common/form/FormInput';

interface AIAssistantSectionProps {
    isEditing: boolean;
    isSaving: boolean;
    assistant: {
        niche: string;
        targetAudience: string;
        contentPurpose: string;
        contentTone: string;
    };
    onChange: (field: string, value: string) => void;
}

const AIAssistantSection: React.FC<AIAssistantSectionProps> = ({
    isEditing,
    isSaving,
    assistant,
    onChange,
}) => {
    if (isEditing) {
        return (
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Target Niche</label>
                    <FormInput
                        type="text"
                        value={assistant.niche}
                        onChange={(e) => onChange('niche', e.target.value)}
                        placeholder="e.g. AI-powered content creation"
                        disabled={isSaving}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Target Audience</label>
                    <FormInput
                        type="text"
                        value={assistant.targetAudience}
                        onChange={(e) => onChange('targetAudience', e.target.value)}
                        placeholder="e.g. solo bloggers and marketing teams"
                        disabled={isSaving}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Content Tone</label>
                    <FormInput
                        type="text"
                        value={assistant.contentTone}
                        onChange={(e) => onChange('contentTone', e.target.value)}
                        placeholder="e.g. professional and authoritative"
                        disabled={isSaving}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Primary Content Purpose</label>
                    <FormInput
                        type="text"
                        value={assistant.contentPurpose}
                        onChange={(e) => onChange('contentPurpose', e.target.value)}
                        placeholder="e.g. facilitate content creation"
                        disabled={isSaving}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Target Niche</label>
                    <p className="text-sm font-medium text-gray-900">{assistant.niche || 'Not set'}</p>
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Target Audience</label>
                    <p className="text-sm font-medium text-gray-900">{assistant.targetAudience || 'Not set'}</p>
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Content Tone</label>
                    <p className="text-sm font-medium text-gray-900">{assistant.contentTone || 'Not set'}</p>
                </div>
                <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Content Purpose</label>
                    <p className="text-sm font-medium text-gray-900">{assistant.contentPurpose || 'Not set'}</p>
                </div>
            </div>
        </div>
    );
};

export default AIAssistantSection;
